export default "__VITE_ASSET__BQy68X1W__"